import type { ReportFilter } from './filter.types'
import type { TrendTableFrequency } from './trendTable.types'

export type ReportTableType =
  | 'table'
  | 'summary_table'
  | 'leaderboard_table'
  | 'comparison_table'
  | 'matrix_table'
  | 'trend_table'

/** Renderer-truthful registry: every selectable type has a distinct presenter branch. */
export const IMPLEMENTED_REPORT_TABLE_TYPES = [
  'table',
  'matrix_table',
  'trend_table',
] as const satisfies readonly ReportTableType[]

export function isImplementedReportTableType(
  value: ReportTableType,
): value is (typeof IMPLEMENTED_REPORT_TABLE_TYPES)[number] {
  return (IMPLEMENTED_REPORT_TABLE_TYPES as readonly ReportTableType[]).includes(value)
}

export interface ReportTableCustomization {
  visibleFields: string[]
  columnOrder: string[]
  frozenFields: string[]
  /** Base metric fields whose previous/change render columns are open. */
  expandedFields?: string[]
  tableType: ReportTableType
  breakdownField: string | null
  /** Trend-table time-bucket size. Ignored by every other table type. */
  frequency?: TrendTableFrequency
  totalRows?: Array<'other' | 'ga4'>
}

export interface ReportTableSavedViewDraft extends ReportTableCustomization {
  name: string
  filters: ReportFilter[]
}

/** Named user draft stays local until the backend exposes named/multi-view semantics. */
export interface ReportTableSavedViewV1 extends ReportTableSavedViewDraft {
  version: 1
  id: string
  updatedAt: string
}

export type ReportCardStatus = 'all' | 'active' | 'disabled'
